// Test helper for follow-up notifications
// Use this in browser console to test notifications

export const createTestFollowUp = (minutesFromNow = 16) => {
  const now = new Date();
  const scheduledTime = new Date(now.getTime() + minutesFromNow * 60000);
  
  const testFollowUp = {
    id: 'test_' + Date.now(),
    leadId: 'test_lead_123',
    leadName: 'Test Lead - Rahul Kumar',
    leadPhone: '9876543210',
    leadEmail: 'test@example.com',
    summary: 'Test follow-up - Discuss pricing and demo',
    scheduledDate: scheduledTime.toISOString(),
    status: 'pending',
    priority: 'high',
    type: 'call',
    createdAt: new Date().toISOString()
  };

  // Get existing follow-ups
  const existing = localStorage.getItem('crm-followups');
  const followUps = existing ? JSON.parse(existing) : [];
  
  // Add test follow-up
  followUps.push(testFollowUp);
  
  // Save back to localStorage
  localStorage.setItem('crm-followups', JSON.stringify(followUps));
  
  // Dispatch event to notify FollowUpNotificationPopup
  console.log('🔔 Dispatching followup-updated event from test');
  window.dispatchEvent(new Event('followup-updated'));
  
  console.log('✅ Test follow-up created!');
  console.log('📅 Scheduled for:', scheduledTime.toLocaleString());
  console.log('⏰ Notification will appear in:', (minutesFromNow - 15), 'minutes');
  console.log('🔔 Refresh page to activate notification system');
  
  return testFollowUp;
};

export const clearTestFollowUps = () => {
  const existing = localStorage.getItem('crm-followups');
  if (!existing) {
    console.log('ℹ️ No follow-ups to clear');
    return;
  }
  
  const followUps = JSON.parse(existing);
  const filtered = followUps.filter(f => !f.id.startsWith('test_'));
  
  localStorage.setItem('crm-followups', JSON.stringify(filtered));
  console.log('✅ Test follow-ups cleared');
};

export const listAllFollowUps = () => {
  const existing = localStorage.getItem('crm-followups');
  if (!existing) {
    console.log('ℹ️ No follow-ups found');
    return [];
  }
  
  const followUps = JSON.parse(existing);
  console.log('📋 Total follow-ups:', followUps.length);
  
  followUps.forEach((f, index) => {
    const scheduledTime = new Date(f.scheduledDate);
    const now = new Date();
    const minutesDiff = Math.floor((scheduledTime - now) / (1000 * 60));
    
    console.log(`${index + 1}. ${f.leadName}`);
    console.log(`   Scheduled: ${scheduledTime.toLocaleString()}`);
    console.log(`   Time until: ${minutesDiff} minutes`);
    console.log(`   Status: ${f.status}`);
    console.log('---');
  });
  
  return followUps;
};

// Make functions available in browser console
if (typeof window !== 'undefined') {
  window.testNotification = {
    create: createTestFollowUp,
    clear: clearTestFollowUps,
    list: listAllFollowUps
  };
  
  console.log('🔧 Test notification helpers loaded!');
  console.log('📝 Available commands:');
  console.log('   testNotification.create(16) - Create test follow-up 16 min from now');
  console.log('   testNotification.list() - List all follow-ups');
  console.log('   testNotification.clear() - Clear test follow-ups');
}
